import { Helmet } from 'react-helmet';
import Navigation from '../Universal/Navigation';
import Footer from '../Universal/Footer';
import EveHero from './EveHero';
import EveOverview from './EveOverview';
import EveSpecs from './EveSpecs';
import DotGrid from '../DotGrid';

const EvePage = () => {

  return (
    <>
      <Helmet>
        <title>ALUREN DYNAMICS</title>
        <link rel="icon" href="/ALUREN WATERMARK.png" />
      </Helmet>
      <div style={{ minHeight: '100vh', color: '#fff', position: 'relative' }}>
      {}
      <div style={{ position: 'fixed', inset: 0, backgroundColor: '#000', zIndex: 0 }} />

      {}
      <div style={{ position: 'fixed', inset: 0, zIndex: 1, pointerEvents: 'none' }}>
        <DotGrid
          dotSize={3}
          gap={12}
          baseColor="#303030"
          activeColor="#5227FF"
          proximity={50}
          shockRadius={50}
          shockStrength={1}
          resistance={750}
          returnDuration={1.5}
          style={{ width: '100%', height: '100%' }}
        />
      </div>

      {}
      <div style={{ position: 'relative', zIndex: 2, pointerEvents: 'auto' }}>
        <Navigation />
        <EveHero />
        <EveOverview />
        <EveSpecs />
        {}
        <Footer />
      </div>
    </div>
    </>
  );
};

export default EvePage;